import script from "./ApplyItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApplyItem.vue?vue&type=script&lang=ts&setup=true"

import "./ApplyItem.vue?vue&type=style&index=0&id=49f27b66&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f27b66"]])

export default __exports__